import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Attributes } from '../../components/Attributes';
import { useXMLViewerContext } from '../../context/xml-viewer-context';
export function DeclarationTag(props) {
    const { indentation, tagKey, attributes } = props;
    const { theme } = useXMLViewerContext();
    return (_jsxs("div", { children: [_jsx("span", { style: { color: theme.separatorColor }, children: `${indentation}<?` }), _jsx("span", { style: { color: theme.tagColor }, children: `${tagKey.slice(1)}` }), _jsx(Attributes, { attributes: attributes }), _jsx("span", { style: { color: theme.separatorColor }, children: '?>' })] }));
}
//# sourceMappingURL=index.js.map